import { createReducer } from '@mews/framework';
import {
    META_STATE_FAILED,
    META_STATE_STARTED,
    META_STATE_SUCCEEDED,
} from '@mews-commander/legacy-entities/src/constants';
import {
    ENTERPRISE_RATE_MANAGEMENT_INIT_FAILED,
    ENTERPRISE_RATE_MANAGEMENT_INIT_STARTED,
    ENTERPRISE_RATE_MANAGEMENT_INIT_SUCCEEDED,
} from '../actionTypes';
import { MetaState } from '../types';

const initialState = {
    isFetching: false,
    hasFailed: false,
};

const metaReducer = createReducer(initialState, {
    [ENTERPRISE_RATE_MANAGEMENT_INIT_STARTED]: (state: MetaState) => ({
        ...state,
        ...META_STATE_STARTED.meta,
    }),
    [ENTERPRISE_RATE_MANAGEMENT_INIT_SUCCEEDED]: (state: MetaState) => ({
        ...state,
        ...META_STATE_SUCCEEDED.meta,
    }),
    [ENTERPRISE_RATE_MANAGEMENT_INIT_FAILED]: (state: MetaState) => ({
        ...state,
        ...META_STATE_FAILED.meta,
    }),
});

export default metaReducer;
